module.exports = __webpack_public_path__ + "static/media/2_pl.f15a63d9.png";